import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const store = new Vuex.Store({
   state: {
    tabbar: "1",
    tabshow: true
  },
  mutations: {
    increment: function(state,n) {
      state.tabbar = n;
    },
    tabstatus: function(state,n) {
      state.tabshow = n;
    }
  }
})
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js